module.exports = __webpack_public_path__ + "img/teams_icon.445aa526.png";